import React, { useState } from 'react';
import axios from 'axios';
import { useAuthClient } from '../../core/context/AuthClientContext';
import { useNavigate } from 'react-router-dom';

const LoginClientModal = ({ onClose, onSwitchToRegister, visible, onSuccessLogin }) => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [message, setMessage] = useState('');
  const authContext = typeof useAuthClient === 'function' ? useAuthClient() : {};
const login = authContext?.login || (() => {});

  const navigate = useNavigate();

  if (!visible) return null;

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    const clientKey = localStorage.getItem("selectedClient");

    try {
      // ✅ Récupérer le CSRF token
      const csrfRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/csrf-token`, {
        withCredentials: true,
        headers: { 'Cache-Control': 'no-cache', 'x-client-key': clientKey || '' }
      });
      const csrfToken = csrfRes.data.csrfToken;

      // ✅ Envoyer la requête de login
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/users/login`,
        formData,
        {
          headers: {
            'X-CSRF-Token': csrfToken,
            'Content-Type': 'application/json',
            'x-client-key': clientKey || ''
          },
          withCredentials: true,
        }
      );

      login(res.data.token, res.data.user);
      setMessage('✅ Connexion réussie !');

      setTimeout(() => {
        onClose();
        if (onSuccessLogin) {
          onSuccessLogin();
        } else {
          navigate('/account');
        }
      }, 500);

    } catch (err) {
      console.error('❌ Erreur login client :', err.response || err);
      setMessage('❌ Identifiants invalides ou erreur CSRF');
    }
  };

  return (
    <div className="theme6-modal-overlay active">
      <div className="theme6-modal">
        <button className="close-btn" onClick={onClose}>✖</button>
        <h2>Connexion client</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Adresse email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Mot de passe"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <button type="submit">Se connecter</button>
        </form>
        {message && <p className="auth-message">{message}</p>}
        <p className="auth-link">
          Pas encore de compte ?{' '}
          <button
            type="button"
            onClick={onSwitchToRegister}
            className="btn-link"
            style={{
              border: 'none',
              background: 'none',
              color: 'var(--theme6-primary)',
              cursor: 'pointer',
              padding: 0,
            }}
          >
            Créer un compte
          </button>
        </p>
      </div>
    </div>
  );
};

export default LoginClientModal;
